import { WifiOff } from 'lucide-react';
import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useState } from 'react';
import { Icon } from '../primitives/Icon.tsx';
import { springs } from '../motion/springs.ts';

export function useOnline() {
  const [online, setOnline] = useState(() => (typeof navigator === 'undefined' ? true : navigator.onLine));
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);
  return online;
}

/** Slim banner shown when offline. Place directly under the top bar. */
export function OfflineBanner({ message }: { message: string }) {
  const online = useOnline();
  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={springs.default}
          className="overflow-hidden bg-status-delayed-soft text-status-delayed"
          role="status"
        >
          <div className="flex items-center gap-2 px-4 py-2 text-caption font-medium">
            <Icon icon={WifiOff} size={16} />
            {message}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
